import SubModule from './SubModule';

export default SubModule;
